<particle-shimmer-loader *ngIf = "!(allDataLoaded$ | async)"
                         [elemCount]="1"
                         [elemPadding]="10"
                         [elemMargin]="0"
                         [isVisible]="!(allDataLoaded$ | async)"
></particle-shimmer-loader>
<particle-tree-selector *ngIf = "(allDataLoaded$ | async)" class="flex flex-col"
                        [tabs]="filterTabs"
                        [title]="title"
                        [treeData]="treeData$"
                        [searchKey]="CurrentSearchKey"
                        [itemViewerName]="'FilterTreeSelectorItemViewer'"
                        [quickSelections]="quickSelections$"
                        [isParentNodeCollapsible]="isParentNodeCollapsible$"
                        (selectionChanged)="onSelectionChanged($event)"
                        (quickSelectionClicked)="onCountryQuickSelectionClick($event)"
                        (onTabChanged)="onTabChanged($event)"></particle-tree-selector>
